import { useState } from "react";

import { CallsService } from "../services/calls.service";

// COMPLETE summaries don't change, so keep them for the session - anything
// else (not found / still processing) is re-fetched next time.
const SUMMARY_CACHE = new Map<string, string>();

export const clearCallSummaryCache = () => {
  SUMMARY_CACHE.clear();
};

export const useCallSummary = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // Set when there's no usable summary (404 or not COMPLETE) - shown as an
  // info message rather than an error.
  const [unavailableReason, setUnavailableReason] = useState<string | null>(null);
  const [summary, setSummary] = useState<string | null>(null);

  const loadSummary = async (callId: string) => {
    const cached = SUMMARY_CACHE.get(callId);
    if (cached) {
      setSummary(cached);
      return;
    }

    setLoading(true);
    setError(null);
    setUnavailableReason(null);
    try {
      const res = await CallsService.getSummary(callId);
      if (!res) {
        setUnavailableReason("No summary is available for this call.");
      } else if (res.summary_status !== "COMPLETE" || !res.summary) {
        setUnavailableReason(`Summary not available yet (${res.summary_status ?? "NOT QUEUED"}).`);
      } else {
        SUMMARY_CACHE.set(callId, res.summary);
        setSummary(res.summary);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not retrieve summary.");
    } finally {
      setLoading(false);
    }
  };

  return { loadSummary, loading, error, unavailableReason, summary };
};
